import type { Review } from '@homeviews/models'

const LABELS_MAP = {
  sustainability_renewable_evergy: {
    label: 'Renewable evergy resources',
  },
  sustainability_recycling_services: {
    label: 'Recycling services',
  },
  sustainability_building_eco_ratings: {
    label: 'Building environmental ratings',
  },
  sustainability_renewable_evergy_saving_measures: {
    label: 'Energy saving measures',
  },
  sustainability_bike_storage: {
    label: 'Bike storage',
  },
  sustainability_parking_alternatives: {
    label: 'Parking alternatives',
  },
  sustainability_sustainable_construction: {
    label: 'Sustainable building materials and construction methods',
  },
  sustainability_private_space: {
    label: 'Access to private green space',
  },
  sustainability_smart_features: {
    label: 'Smart features to improve facilities management',
  },
}
export const getSustainabilityValues = (review: Review) => {
  const labels = []

  Object.keys(LABELS_MAP).map((key: string) => {
    if (review?.[key] === 'yes' && LABELS_MAP[key]['label']) {
      labels.push(LABELS_MAP[key]['label'])
    }
  })

  return labels
}
